module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "slate-int-default-container"
    }
  }, [_vm._t("default", [_vm._v("Default interactive text")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/template-compiler.js?id=data-v-13c5a390!/Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/selector.js?type=template&index=0!/Users/andrewkahn/Documents/experiments/slate-interactives/src/components/slate-int-default-container/src/DefaultContainer.vue
// module id = 108
// module chunks = 0